import { render, staticRenderFns } from "./PromoCodeFilter.vue?vue&type=template&id=1167f5a3&"
import script from "./PromoCodeFilter.vue?vue&type=script&lang=js&"
export * from "./PromoCodeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports